import { createFileRoute } from '@tanstack/react-router';
import { SDKKeysPage } from '@/components/settings/sdk';

export const Route = createFileRoute('/_dashboard/admin/org/sdk-keys')({
  component: SDKKeysSettingsPage,
});

function SDKKeysSettingsPage() {
  return <SDKKeysPage />;
}
